import { Util, Request } from "@xt/xtbase";
import { getOrigin1 } from "../utils/method";
import generateFlatMethods from "./method";
const { XtAxios4, XtAxios } = Request;

const { getOrigin } = Util;
const baseUrl = getOrigin("www") + "/rfapi";

const {
  get,
  put,
  post,
  del,
} = generateFlatMethods(baseUrl);


const requestGenerate = (method, url) => (data, config, special) => method(`${url}${special ? `?${special}` : ''}`, data, config);

export const getUbaseCoinSymbolList = () => XtAxios.get(`${getOrigin("www")}/fapi/market/v1/public/symbol/list?isPredict=true&isDelivery=true`);

export const getCbaseCoinSymbolList = () => XtAxios.get(`${getOrigin("www")}/dapi/market/v1/public/symbol/list?isPredict=true&isDelivery=true`);

export const uploadFileUrl = getOrigin1('www') + "/rfapi" + "/upload/s3";

// 文件上传
export const uploadFile = requestGenerate(post, `/upload/s3`);

// 获取数据看版overview
export const getDataBoardOverview = requestGenerate(get, `/partner/data-board/overview`);

// 获取最近七天注册数据
export const getLatestRegisterList = requestGenerate(get, `/partner/data-board/recent-register`);

// 获取概览每日数据
export const getDataBoardDailyData = requestGenerate(get, `/partner/data-board/daily-data`);

// 查询列表
export const getPartnerUserList = requestGenerate(get, `/partner/user`);

// 添加直客
export const addPartnerUser = requestGenerate(post, `/partner/user`);

// 佣金申请提现查询
export const getWithdrawList = requestGenerate(get, `/partner/commission-apply`);

// 佣金申请提现
export const applyWithdraw = requestGenerate(post, `/partner/commission-apply`);

// 佣金申请提现可用币种信息下拉列表
export const getWithdrawCoinList = requestGenerate(get, `/partner/currency-list`);

// 交易对下拉列表
export const getSymbolList = requestGenerate(get, `/partner/common/symbol-options`);

// 合伙人下拉选框
export const getPartnerList = requestGenerate(get, `/partner/common/partner-options`);

// 下级直客
export const getDownDirector = requestGenerate(get, `/partner/common/down-director`);

// 合伙人排行榜
export const getPartnerRank = requestGenerate(get, `/public/partner/rank`);

// 查询合伙人管理列表
export const getPartnerManageList = requestGenerate(get, `/partner/partner`);

// 获取合伙人信息（更新时间和周期）
export const getPartnerInfo = requestGenerate(get, `/partner/partner/info`);

// 修改合伙人
export const updatePartnerManage = requestGenerate(put, `/partner/partner`);

// 添加合伙人
export const addPartnerManage = requestGenerate(post, `/partner/partner`);

// 退回直客/合伙人降级为直客
export const updatePartnerDrop = requestGenerate(put, `/partner/partner/drop`);

// 导出
export const getPartnerManageListExport = requestGenerate(get, `/partner/partner/export`);

// 修改合伙人
export const updateRemark = requestGenerate(put, `/partner/partner/remark`);

// 合约交易查询
export const getFutureTrade = requestGenerate(get, `/partner/user/trade/future`);

// 合约交易导出
export const getFutureTradeExport = requestGenerate(get, `/partner/user/trade/future-export`);

// 现货交易查询
export const getSpotTrade = requestGenerate(get, `/partner/user/trade/spot`);

// 现货交易导出
export const getSpotTradeExport = requestGenerate(get, `/partner/user/trade/spot-export`);

// 左侧用户树
export const getLeftUserTreeData = requestGenerate(get, `/partner/user/trade/user-tree`);

// 查询列表
export const getUserList = requestGenerate(get, `/partner/user`);

// 添加直客
export const addDirector = requestGenerate(post, `/partner/user`);

// 用户列表导出
export const exportUserList = requestGenerate(post, `/partner/user/export`);

// 修改用户备注
export const updateUserRemark = requestGenerate(put, `/partner/user/remark`);

// 升级为合伙人
export const upgradeUser = requestGenerate(put, `/partner/user/upgrade`);

// 编辑合伙人
export const editPartner = requestGenerate(put, `/partner/user/edit-commission`);

// 修改合伙人
export const updatePartner = requestGenerate(put, `/partner/partner/down-partner`);

// 用户返佣信息
export const getUserProfile = requestGenerate(get, `/profile/info`);

// 删除被邀请人
export const deleteInvitedUser = requestGenerate(del, `/profile/invitee`);

// 被邀请人列表
export const getInvitedUserList = requestGenerate(get, `/partner/common/invitees`);

// 新增推荐
export const addNewRecommend = requestGenerate(post, `/invite-code`);

// 邀请码列表
export const getInvitedCodeList = requestGenerate(get, `/invite-code/list`);

// 合伙人邀请码
export const getPartnerInvitedCode = requestGenerate(get, `/partner/common/inviteCode`);

// 推荐--设为默认
export const updateRecommendDefault = (defaultId) => put(`/invite-code/default/${defaultId}`);

// 推荐--修改备注
export const updateRecommendRemark = (id, data) => put(`/invite-code/remark/${id}`, data);

// 直客返佣查询
export const getCommissionDirector = requestGenerate(get, `/partner/commission/director`);

// 直客佣金统计
export const getCommissionDirectorTotal = requestGenerate(get, `/partner/commission/director-statistics`);

// 下级合伙人佣金查询
export const getLevelCommissionDirector = requestGenerate(get, `/partner/commission/down-partner`);

// 下级合伙人佣金-佣金统计
export const getLevelCommissionDirectorTotal = requestGenerate(get, `/partner/commission/partner-statistics`);

// 渠道或者合伙人用户可分配的返佣比例上限
export const getUserCommissionLimit = requestGenerate(get, `/partner/common/commission-limit`);

// 直客佣金导出
export const exportDirector = requestGenerate(get, `/partner/commission/director-export`);

// 下级合伙人佣金-导出
export const exportDownDirector = requestGenerate(get, `/partner/commission/down-partner-export`);

// 用户出入金查询
export const fetchMoneyDetails = requestGenerate(get, `/partner/user/cash`);

// 获取风控通知
export const getRiskNotice = requestGenerate(get, '/partner/user/risk-notice');

// 获取风控规则
export const getRiskRules = requestGenerate(get, '/partner/user/risk-rule');

// 获取返佣明细汇总
export const getCommissionDetailSummary = requestGenerate(get, '/commission-data/detail/summary');

// 获取返佣明细列表
export const getCommissionDetailList = requestGenerate(get, '/commission-data/detail/list');

// 获取返佣明细详情
export const getCommissionDetailById = (id, type) => {
  const params = {};
  if (type) {
    params.type = type;
  }
  return XtAxios.get(`${baseUrl}/commission-data/detail/${id}`, { params });
};

// 导出返佣明细列表
export const exportCommissionDetailList = (params, config) => {
  return XtAxios.get(`${baseUrl}/commission-data/detail/list/export`, {
    params,
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.ms-excel',
    },
    ...config,
  });
};